
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderGiftCardsGrid1 extends Serenity.EntityGrid<OrderGiftCardsRow, any> {
        protected getColumnsKey() { return OrderGiftCardsColumns.columnsKey; }
        protected getDialogType() { return OrderGiftCardsDialog; }
        protected getIdProperty() { return OrderGiftCardsRow.idProperty; }
        protected getInsertPermission() { return OrderGiftCardsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderGiftCardsRow.localTextPrefix; }
        protected getService() { return OrderGiftCardsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {

            this.editItem({ OrderId: this.OrderId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {

            return this.OrderId != null;
        }


        private _OrderId: number;

        get OrderId() {
            return this._OrderId;
        }
        set OrderId(value: number) {
            if (this._OrderId != value) {
                this._OrderId = value;
                this.setEquality(OrderGiftCardsRow.Fields.OrderId, value);
                this.refresh();
            }
        }
    }
}